import { createContractRequest } from './helper';
export const getOfferDocumentsMetaData = createContractRequest({
    route: '/contract/offers/:offerId/documentsMetadata',
    method: 'get',
    source: 'data',
});
